import { render, staticRenderFns } from "./BuilderCclone.vue?vue&type=template&id=460869b0&lang=pug"
import script from "./BuilderCclone.vue?vue&type=script&lang=js"
export * from "./BuilderCclone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports